import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { shouldShowOnboarding } from '../services/onboardingService';

const RoleBasedRedirect: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    // Solo aplicar reglas al acceder a la raíz
    if (location.pathname !== '/') return;

    // Invitado (no autenticado): quedarse en '/' o mostrar home público
    if (!isAuthenticated || !user) {
      return;
    }

    // Admin siempre va directo a su panel (sin onboarding)
    if (user.role === 'admin') {
      navigate('/admin/combined', { replace: true });
      return;
    }

    // Usuario regular: verificar si debe ver onboarding
    if (user.id && shouldShowOnboarding(user.id)) {
      console.log('🚀 Primera sesión detectada, redirigiendo a onboarding...');
      navigate('/onboarding', { replace: true });
    } else {
      // Usuario regular que ya completó onboarding
      navigate('/user-home', { replace: true });
    }
  }, [user, isAuthenticated, navigate, location.pathname]);

  return null;
};

export default RoleBasedRedirect;